import type { AppConfigsFormConfiguration, AppConfigsFormJson } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";

export const normalizeConfigMap = (configMap: Record<string, AppConfigsFormConfiguration[]>): AppConfigsFormJson =>
    Object.values(configMap)
        .map((configArray) =>
            configArray.map((config) => ({
                ...config,
                configTabs: config.configTabs
                    ? config.configTabs.flat().map((tab) => ({
                          ...tab,
                          configFields: tab.configFields ? tab.configFields.flat() : undefined,
                      }))
                    : undefined,
            })),
        )
        .flat();
